/**
 * @author emil.ohman@svenskaspel.se (Emil Öhman)
 */

import PropTypes from 'prop-types';
import './../stylesheets/badge.less';

/**
 * Badge is available in three different sizes and colors.
 * Check prop table for how to animate a badge.
 */
const Badge = ({ branding = 'default', size = 'standard', hide, bounce, className, children }) => {
  const classNames = ['badge'];

  if (branding) {
    classNames.push(`badge-${branding}`);
  } else {
    classNames.push('badge-default');
  }

  if (size) {
    classNames.push(`badge-${size}`);
  }

  if (hide) {
    classNames.push(`badge-hide`);
  }

  if (bounce) {
    classNames.push(`badge-bounce`);
  }

  if (className) {
    classNames.push(className);
  }

  return (
    <span className={classNames.join(' ')}>
      {children}
    </span>
  );
};

Badge.propTypes = {
  /**
   * Set bounce to true to run keyframe animation of bounce.
   */
  bounce: PropTypes.bool,
  /**
   * Branding, buildt in support for default, red and orange.
   */
  branding: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf(['default', 'red', 'orange'])
  ]),
  /**
   * Content
   */
  children: PropTypes.node,
  /**
   * Custom css classes.
   */
  className: PropTypes.string,
  /**
   * Prepare to animate, adds visibility: hidden.
   */
  hide: PropTypes.bool,
  /**
   * Size of the badge, defaults to standard.
   */
  size: PropTypes.oneOf(['standard', 'small', 'large'])
};

export default Badge;
